import React, { PureComponent } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Callout } from 'formlabs-web-components/Type';

import './Callout.module.css';

const CalloutSection = DisplayComponent(
  class CalloutSection extends PureComponent {
    render() {
      const {
        headerPosition,
        headerColor,
        callouts,
        calloutSectionId,
        iconColor,
        children,
        classes
      } = this.props;
      return (
        <div
          id={calloutSectionId}
          className={classes}
          style={{ marginTop: '6rem' }}
        >
          {headerPosition === 'top' && (
            <div styleName="top-header">
              <Grid direction="x" primaryAlignment="align-center">
                <Cell largeSize={16}>
                  <div
                    className="mobile-padding"
                    style={{ textAlign: 'center' }}
                  >
                    {children}
                  </div>
                </Cell>
              </Grid>
              <Grid
                direction="x"
                primaryAlignment="align-center"
                styles={{ marginTop: '60px' }}
              >
                {callouts.map(callout => {
                  return (
                    <Cell
                      key={callout.id}
                      largeSize={6}
                      styles={{ boxSizing: 'border-box', padding: '30px' }}
                    >
                      <Callout {...callout} iconColor={iconColor} />
                    </Cell>
                  );
                })}
              </Grid>
            </div>
          )}

          {headerPosition === 'left' && (
            <div styleName="header-left">
              <Grid direction="x">
                <Cell largeSize={8} styles={{ display: 'flex' }}>
                  <div
                    styleName="header-padding"
                    style={{
                      backgroundColor: headerColor
                    }}
                  >
                    {children}
                  </div>
                </Cell>
                <Cell largeSize={16}>
                  <div styleName="header-left-padding">
                    <Grid direction="x" styles={{ position: 'relative' }}>
                      <div styleName="border-override" />
                      {callouts.map(callout => {
                        return (
                          <Cell
                            key={callout.id}
                            largeSize={12}
                            mediumSize={12}
                            styles={{ display: 'flex' }}
                          >
                            <div styleName={`single-callout border-callout`}>
                              <Callout {...callout} iconColor={iconColor} />
                            </div>
                          </Cell>
                        );
                      })}
                    </Grid>
                  </div>
                </Cell>
              </Grid>
            </div>
          )}

          {headerPosition === 'none' && (
            <div styleName="header-none">
              <div
                styleName="no-header-contents"
                style={{ background: headerColor }}
              >
                <Grid
                  direction="x"
                  primaryAlignment="align-spaced"
                  styles={{
                    position: 'relative'
                  }}
                >
                  {callouts.map(callout => {
                    return (
                      <Cell key={callout.id} largeSize={7} mediumSize={11}>
                        <div styleName={`single-callout no-header`}>
                          <Callout {...callout} iconColor={iconColor} />
                        </div>
                      </Cell>
                    );
                  })}
                </Grid>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);

CalloutSection.propTypes = {};

export default CalloutSection;
